import gsap from "gsap/all";

export default () => ({
  btnHoverColor: getComputedStyle(document.body).getPropertyValue(
    "--btn-hover"
  ),

  init() {
    const videoContainer = document.querySelectorAll(".jonnitto-prettyembed");

    videoContainer.forEach((container) => {
      const playButton = container
        .querySelector(".button-play")
        .querySelector(":first-child");

      if (window.innerWidth >= 1024) {
        container.addEventListener("mouseenter", () => {
          this.onHover(playButton);
        });

        container.addEventListener("mouseleave", () => {
          this.onLeave(playButton);
        });
      }
    });
  },

  onHover(playButton) {
    gsap
      .timeline()
      .to(playButton, {
        y: -25,
        ease: "back.out(2.5)",
        duration: 0.4,
        delay: 0.1,
      })
      .to(
        playButton,
        {
          borderRadius: "100%",
          backgroundColor: this.btnHoverColor,
          scale: 0.85,
          duration: 0.4,
          delay: 0.1,
        },
        0
      );
  },

  onLeave(playButton) {
    gsap
      .timeline()
      .to(playButton, {
        y: 0,
        ease: "back.out(2.5)",
        duration: 0.25,
      })
      .to(
        playButton,
        {
          borderRadius: 0,
          backgroundColor: "#FFA01E",
          scale: 1,
          duration: 0.3,
        },
        0
      );
  },
});
